module.exports = __webpack_public_path__ + "img/sosLevel1.c77d4ee8.png";